import { connect } from 'react-redux';
import { removeNotificationFromQueue } from '../redux/actionCreators';
import { getNotificationQueue } from '../redux/selectors';
const mapStateToProps = (state, { queueName })=>({
        notifications: getNotificationQueue(state, queueName)
    });
const mapDispatchToProps = {
    removeNotification: removeNotificationFromQueue
};
export default connect(mapStateToProps, mapDispatchToProps);
